import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import { AboutMeTypes } from '../StepThreeTypes';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';

interface HowToCommunicateProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const HowToCommunicate: React.FC<HowToCommunicateProps> = ({
  aboutMe,
  setAboutMe,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="how-to-communicate"
        >
          How I communication and how to communicate with me
        </label>
      </h1>
      <div className="govuk-body">
        A description of how you communicate normally including any
        communication aids you use, for example a hearing aid. Include your
        preferred language of communication, if your first language is not
        English.
      </div>
      <div className="govuk-body">
        Include how you would communicate when you are in pain or distress.
        Include how you communicate choices. Include how you give feedback or
        raise a concern. Include how you like to receive information Describe
        how you would like others to engage and communicate with you, including
        how you would like to be addressed.
      </div>
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Prompt questions</span>
        </summary>
        <div className="govuk-details__text">
          <div className="govuk-body">
            1. What do people caring for you and supporting you need to know
            about how you communicate and how they should communicate with you?
          </div>
          <div className="govuk-body">
            Consider: the language you prefer to communicate in. whether you
            communicate by, for example, signing, symbols, Picture Exchange
            Communication System (PECS), gestural or body language. how you like
            to be addressed whether you use a communication aid (high or low
            tech) (If so, who provides maintenance and technical support?).
            whether people speaking to you need to speak slowly and clearly.
          </div>
          <div className="govuk-body">
            2. How do you let people know you are in pain, anxious or in
            distress? For example, do you communicate it verbally, facially or
            through body language?
          </div>
          <div className="govuk-body">
            3. How do you make choices? When offered a verbal choice do you
            always make an informed choice, or do you need those supporting you
            to explain choices in detail?
          </div>
          <div className="govuk-body">4. How do you indicate yes and no?</div>
          <div className="govuk-body">
            5. How do you give feedback or raise a concern?
          </div>
          <div className="govuk-body">
            6. What support would help you understand what is happening and what
            treatment you might need in hospital?
          </div>
          <div className="govuk-body">
            7. When is a good and bad time to have important conversations with
            you?
          </div>
        </div>
      </details>

      <div className="govuk-body">
        Describe how you would like others to engage and communicate with you,
        including how you would like to be addressed.
      </div>

      <VoiceToTextTextarea
        id="how-to-communicate"
        name="howToCommnunicate"
        value={aboutMe.howToCommnunicate || ''}
        rows={5}
        autoComplete="how-to-communicate"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value =>
          setAboutMe({
            ...aboutMe,
            howToCommnunicate: value,
          })
        }
      />
    </div>
  );
};

export default HowToCommunicate;
